import React from 'react';

// import { Container, Headline } from './FormSection.style';
// import SubredditForm from './SubredditForm';
import FormSection from './FormSection';
import HeatmapSection from './HeatmapSection';

function SearchPage() {
  return (
    <>
      <FormSection />
      <HeatmapSection />
    </>
  );
}

export default SearchPage;
